import React from 'react';

import cn from 'classnames';
import { Controller } from 'react-hook-form';

import { DateHelpers } from '@shared/helpers';
import { UiDateInput } from '@shared/ui';

import { IFormFieldProps } from '../../../model/types';

import cls from '@widgets/EventJournal/ui/EventJournalModal/EventJournalModal.module.css';

export const EventDateField = ({ isDisabled, error, control, t }: IFormFieldProps) => (
    <Controller
        key="eventDate"
        name="eventDate"
        control={control}
        rules={{
            required: t('field.required'),
        }}
        render={({ field }) => (
            <div className={cls.DateInputWrapper}>
                <UiDateInput
                    {...field}
                    error={{
                        isError: error?.length > 0,
                        errorMessage: error,
                    }}
                    placeholder={t('JournalEvents.EventJournalModal.DateInput.placeholder')}
                    className={cn(cls.DateInput, error && error.length > 0 && cls.error)}
                    calendarIconClassNames={cls.CalendarIconClassNames}
                    disabled={isDisabled}
                    maxDate={DateHelpers.today().format('YYYY-MM-DD')}
                />
            </div>
        )}
    />
);
